import { THROWING_STAR_VISUALS as V } from '../../../config/abilities/throwingStarVisuals.config';
import type { ProjectileShapeBuilder } from './ProjectileShapes';

type Point = { x: number; y: number };

function turn(x: number, y: number, blade: number): Point {
  // Exact quarter-turns keep geometry deterministic, centered and bounded.
  switch (blade) {
  case 1: return { x: -y, y: x };
  case 2: return { x: -x, y: -y };
  case 3: return { x: y, y: -x };
  default: return { x, y };
  }
}

/** Four swept blades, fitted to the projectile's actual width and height. */
export function throwingStarPoints(width: number, height = width): Point[] {
  const points: Point[] = [];
  for (let blade = 0; blade < 4; blade++) {
    for (const [x, y] of [[0, -1], [0.45, -0.45], [0.18, -0.12]]) {
      const point = turn(x, y, blade);
      points.push({ x: point.x * width / 2, y: point.y * height / 2 });
    }
  }
  return points;
}

export const buildThrowingStar: ProjectileShapeBuilder = (g, config, color) => {
  const width = config.width ?? V.bodySize;
  const height = config.height ?? width;
  const points = throwingStarPoints(width, height);
  g.fillPolygon(points, color, 1);
  g.strokePolyline([...points, points[0]], V.edgeColor, V.edgeWidth, 1);
  for (let blade = 0; blade < 4; blade++) {
    const facet = [[0, -0.92], [0.18, -0.18], [0, 0]].map(([x, y]) => {
      const point = turn(x, y, blade);
      return { x: point.x * width / 2, y: point.y * height / 2 };
    });
    g.fillPolygon(facet, V.highlightColor, V.facetAlpha);
  }
  const size = Math.min(width, height);
  g.fillCircle(0, 0, size * V.hubRadiusRatio, V.edgeColor, 1);
  g.strokeCircle(0, 0, size * V.hubRadiusRatio, V.highlightColor, V.edgeWidth, V.facetAlpha);
  g.fillCircle(0, 0, size * V.hubInsetRatio, color, 1);
};
